/**
 * Minimal shape of the `gtag.js` global that the Google Analytics snippet in
 * `index.html` installs on `window`. Kept intentionally narrow — we only ever
 * call `gtag(command, ...args)`, never read anything back from it.
 */
export type GtagFn = (...args: unknown[]) => void;

export type WindowWithGtag = Window & typeof globalThis & { gtag?: GtagFn };

/** Reads `window.gtag` without an `any` cast; returns `undefined` if absent. */
export function getGtag(): GtagFn | undefined {
  return (window as WindowWithGtag).gtag;
}
